var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0028 16.75C9.86477 16.75 9.75287 16.8619 9.75279 16.9998L9.75 22.0004L8.25 21.9996L8.25279 16.999C8.25333 16.0329 9.03669 15.25 10.0028 15.25H14C14.9665 15.25 15.75 16.0335 15.75 17V22H14.25V17C14.25 16.8619 14.1381 16.75 14 16.75H10.0028Z",
    fill: "#76B72A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7739 3.56523C12.32 3.20742 11.68 3.20742 11.2261 3.56523L4.22614 9.08351C3.92546 9.32054 3.75 9.68229 3.75 10.0651V20.0001C3.75 20.6905 4.30964 21.2501 5 21.2501H19C19.6904 21.2501 20.25 20.6905 20.25 20.0001V10.0651C20.25 9.68227 20.0746 9.32053 19.7739 9.08351L20.2382 8.49452L19.7739 9.08351L12.7739 3.56523ZM10.2975 2.38724C11.296 1.60009 12.704 1.60009 13.7025 2.38724L20.7025 7.90552C21.364 8.42701 21.75 9.22288 21.75 10.0651V20.0001C21.75 21.519 20.5188 22.7501 19 22.7501H5C3.48122 22.7501 2.25 21.519 2.25 20.0001V10.0651C2.25 9.22284 2.63602 8.42699 3.2975 7.90553L3.76182 8.49452L3.2975 7.90553L10.2975 2.38724L10.7592 2.9729L10.2975 2.38724Z",
    fill: "#76B72A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHome);
export default __webpack_public_path__ + "static/media/ic-home.29ac2f246981d1e6fb90c67df7ce664e.svg";
export { ForwardRef as ReactComponent };